import { paginationFailure, paginationRequest, paginationSuccess } from './actions';
import { PROMOS_REQUEST_ERROR } from '../../constants/notifications';
import { selectProducts } from '../../selectors/analytics';
import { selectCurrentPage } from '../../selectors/pagination';
import { resolveSearchPromosPage } from '../../services/promosSearch';
import { TThunkAction } from '../../types/redux/thunk';
import { setTrackingProducts } from '../../utils/analytics';
import { createTerm } from '../../utils/jsonQuery/createTerm';
import { mergeJsonQuery } from '../../utils/jsonQuery/mergeJsonQuery';
import { setError } from '../error';

/**
 * Redux action, который запрашивает объявления с текущем состоянием nextJsonQuery
 */
export const promosPaginationRequestAction =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi, custom }) => {
    const state = getState();
    const jsonQuery = state.nextJsonQuery;
    const page = selectCurrentPage(state);

    const nextPage = page + 1;
    const pageTerm = { page: createTerm<number>(nextPage) };

    const nextJsonQuery = mergeJsonQuery(jsonQuery, pageTerm);

    const subdomain = custom.subdomain;

    try {
      dispatch(paginationRequest());

      const newData = await resolveSearchPromosPage({
        httpApi,
        logger,
        jsonQuery: nextJsonQuery,
        subdomain,
      });

      dispatch(paginationSuccess(newData));

      const nextProducts = selectProducts(getState());
      setTrackingProducts(nextProducts);
    } catch (e) {
      dispatch(paginationFailure());
      dispatch(setError({ id: Date.now(), message: PROMOS_REQUEST_ERROR }));
    }
  };
